import { useState, useRef, useEffect, useCallback } from 'react'

export function useCodeTimer(initialSeconds = 120) {
  const [seconds, setSeconds] = useState(initialSeconds)
  const [expired, setExpired] = useState(false)
  const intervalRef = useRef(null)

  const start = useCallback(
    (duration = initialSeconds) => {
      setExpired(false)
      setSeconds(duration)
      if (intervalRef.current) clearInterval(intervalRef.current)
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(intervalRef.current)
            intervalRef.current = null
            setExpired(true)
            return 0
          }
          return prev - 1
        })
      }, 1000)
    },
    [initialSeconds]
  )

  const stop = useCallback(() => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [])

  useEffect(() => () => stop(), [stop])

  const formatted = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0')

  return { seconds, formatted, expired, start, stop }
}
